export default __webpack_public_path__ + "assets/images/7e02a730b2735173d34e752a119fbaea.svg";